import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { PreviewEmailRPC } from "./previewEmailRPC";

export class PreviewEmailRPCClientImpl extends PreviewEmailRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: PreviewEmailRPC.Request): Promise<LeoRPCResult<PreviewEmailRPC.Response, PreviewEmailRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/PreviewEmail",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      PreviewEmailRPC.ResponseDTO,
      PreviewEmailRPC.Errors.ErrorsDTO,
      PreviewEmailRPC.Response,
      PreviewEmailRPC.Errors.Errors
    >(
      response,
      "email-cycle/PreviewEmail",
      PreviewEmailRPC.Response.fromDTO,
      PreviewEmailRPC.Errors.fromDTO
    );
  }
}
